import React, { Component } from 'react'

import classes from './SetLevel.scss'
import InputGroup from '../../../../../../components/UI/Forms/InputGroup/InputGroup'
import Button from '../../../../../../components/UI/Button/Button'
import Spinner from '../../../../../../components/UI/Spinner/Spinner'
import withTranslate from 'react-redux-multilingual/lib/withTranslate'

class SetLevel extends Component {
  state = {
    assessor_group: [],
    checkBox: [],
    assessor_data: {},
    weightAll: []
  }

  static getDerivedStateFromProps = (props, state) => {
    let updatedState = {}
    if (
      props.selected &&
      props.levelTable.assessor !== state.assessor_group &&
      state.assessor_group.length === 0
    ) {
      let level_group_id = props.selectAss.row
      let structure_id = props.selectAss.col
      let selectassessor = props.selected.level_structures.find(item => {
        return item.level_group_id === level_group_id && item.structure_id === structure_id
      })
      if (selectassessor) {
        let assessor_group = props.levelTable.assessor.map(item => {
          let target = selectassessor.assessor_group_criteria.find(select => {
            return select.assessor_group_id === item.value_list_id
          })

          return {
            value_list_id: item.value_list_id,
            value_list_name: item.value_list_name,
            weight_percent: target ? target.weight_percent : '',
            is_active: item.is_active,
            assessor_group_criteria: item.assessor_group_criteria,
            check: !!target
          }
        })

        props.saveAss(assessor_group)

        if (props.assessor_group.length !== 0 && props.assessor_group !== state.weightAll) {
          let level_group_id = props.selectAss.row
          let structure_id = props.selectAss.col
          let selectassessor = props.weightAll.find(item => {
            return item.level_group_id === level_group_id && item.structure_id === structure_id
          })

          assessor_group = props.levelTable.assessor.map(item => {
            let target = selectassessor.assessor_group_criteria.find(select => {
              return (
                select.value_list_id === item.value_list_id ||
                select.assessor_group_id === item.value_list_id
              )
            })

            return {
              value_list_id: item.value_list_id,
              value_list_name: item.value_list_name,
              weight_percent: target ? target.weight_percent : '',
              is_active: item.is_active,
              assessor_group_criteria: item.assessor_group_criteria,
              check: !!target
            }
          })

          // assessor_group = props.
          // assessor_group = props.assessor_group.map(item => {
          //   return {
          //     value_list_id: item.value_list_id,
          //     value_list_name: item.value_list_name,
          //     weight_percent: item.weight_percent,
          //     is_active: item.is_active,
          //     check: false,
          //   }
          // })

          updatedState = {
            ...updatedState,
            weightAll: props.assessor_group
          }
        }
        props.saveAss(assessor_group)
        updatedState = {
          ...updatedState,
          assessor_group: assessor_group
        }
      } else {
        let assessor_group = props.levelTable.assessor.map(item => {
          return {
            value_list_id: item.value_list_id,
            value_list_name: item.value_list_name,
            weight_percent: item.weight_percent,
            is_active: item.is_active,
            check: false
          }
        })
        let weight_percent = props.weightAll.find(
          item =>
            item.level_group_id === props.selectAss.row && item.structure_id === props.selectAss.col
        )

        if (weight_percent) {
          if (
            weight_percent.assessor_group_criteria.length !== 0 &&
            weight_percent.assessor_group_criteria !== state.weightAll
          ) {
            assessor_group = weight_percent.assessor_group_criteria.map(item => {
              return {
                value_list_id: item.value_list_id,
                value_list_name: item.value_list_name,
                weight_percent: item.weight_percent,
                is_active: item.is_active,
                check: false
              }
            })

            updatedState = {
              ...updatedState,
              weightAll: weight_percent
            }
          }
        }

        updatedState = {
          ...updatedState,
          assessor_group: assessor_group
        }
      }
    }
    if (!props.selected && state.assessor_group.length === 0) {
      let assessor_group = props.levelTable.assessor.map(item => {
        return {
          value_list_id: item.value_list_id,
          value_list_name: item.value_list_name,
          weight_percent: item.weight_percent,
          is_active: item.is_active,
          check: false
        }
      })
      let weight_percent = props.weightAll.find(
        item =>
          item.level_group_id === props.selectAss.row && item.structure_id === props.selectAss.col
      )

      if (weight_percent) {
        if (
          weight_percent.assessor_group_criteria.length !== 0 &&
          weight_percent.assessor_group_criteria !== state.weightAll
        ) {
          assessor_group = weight_percent.assessor_group_criteria.map(item => {
            return {
              value_list_id: item.value_list_id,
              value_list_name: item.value_list_name,
              weight_percent: item.weight_percent,
              is_active: item.is_active,
              check: false
            }
          })

          updatedState = {
            ...updatedState,
            weightAll: weight_percent
          }
        }
      }

      updatedState = {
        ...updatedState,
        assessor_group: assessor_group
      }
    }

    if (state.checkBox.length === 0) {
      let checkBox = state.assessor_group.map(item => {
        return {
          value_list_id: item.value_list_id,
          check: false
        }
      })

      updatedState = {
        ...updatedState,
        checkBox: checkBox
      }
    }

    return updatedState
  }

  inputChanged(id, event) {
    let assessor_group = this.state.assessor_group

    assessor_group = this.state.assessor_group.map(item => {
      if (item.value_list_id === id) {
        return {
          ...item,
          weight_percent: event.target.value
        }
      } else return item
    })

    this.setState({
      assessor_group: assessor_group
    })
    this.props.saveAss(assessor_group)
  }

  handleCheck = id => {
    let assessor_group = this.state.assessor_group

    assessor_group = this.state.assessor_group.map(item => {
      if (item.value_list_id === id) {
        return {
          ...item,
          check: !item.check
        }
      } else return item
    })

    this.setState({
      assessor_group: assessor_group
    })
  }

  checkValid = () => {
    let weight = 0
    this.state.assessor_group.map(item => {
      weight = weight + (parseInt(item.weight_percent) || 0)
      return item
    })

    if (weight === 0 || weight === 100) {
      // this.props.checkWeigth(false)
      return false
    } else {
      // this.props.checkWeigth(true)
      return true
    }
  }

  render() {
    let form = <Spinner />
    if (this.state.assessor_group) {
      form = (
        <div className={classes.AssessorContent}>
          {this.checkValid() ? (
            <div style={{ color: 'red' }}>
              {this.props.translate('totalWeightValidationHelperText')}
            </div>
          ) : null}
          {this.state.assessor_group.map(item => (
            <div key={item.value_list_id} className={classes.Ass}>
              {/* <Checkbox
            checked={item.check}
            onChange={ () => this.handleCheck(item.value_list_id)}
            /> */}

              <InputGroup
                inputType={'input'}
                label={item.value_list_name}
                // configs={}
                // disabled={true}
                changed={e => this.inputChanged(item.value_list_id, e)}
                inputValue={item.weight_percent}
              />
            </div>
          ))}
        </div>
      )
    }

    return (
      <div>
        {form}
        <div className={classes.Ass}>
          {/* <Button className={classes.Button}>ssss</Button><Button className={classes.Button}>ssss</Button> */}
        </div>
        <div className={classes.Button}>
          <Button
            size='medium'
            variant='contained'
            disabled={this.checkValid()}
            clicked={e => this.props.Next()}
            color='primary'>
            {this.props.translate('next')}
          </Button>
        </div>
      </div>
    )
  }
}

export default withTranslate(SetLevel)
